import { render, staticRenderFns } from "./TodayCard.vue?vue&type=template&id=5c2a0405&"
import script from "./TodayCard.vue?vue&type=script&lang=js&"
export * from "./TodayCard.vue?vue&type=script&lang=js&"
import style0 from "./TodayCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports